var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDoubleArrowIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 12,
    fill: "none",
    viewBox: "0 0 13 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.5552 6.3547a.501.501 0 0 0 0-.708L7.0549 3.1466a.501.501 0 0 0-.7079 0 .501.501 0 0 0 0 .7079l2.1471 2.1471-2.1455 2.1471a.501.501 0 0 0 0 .7079.501.501 0 0 0 .7079 0l2.5002-2.5003zM4.0546 8.8549l2.5003-2.5002a.501.501 0 0 0 0-.708L4.0546 3.1466a.501.501 0 0 0-.7079 0 .501.501 0 0 0 0 .7079l2.1471 2.1471-2.1455 2.1471a.501.501 0 0 0 0 .7079.501.501 0 0 0 .7078 0z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDoubleArrowIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/double-arrow-icon.73e1c4929eba6b198a3cafae4c161910.svg";